import { RolService } from 'src/app/services/rol.service';
import { CaseInfo } from 'src/app/modules/cases/interfaces/cases-data.interface';

export class ApprovalByCase {
  private _caseInformation: CaseInfo;

  constructor(private caseinfo: CaseInfo, private readonly rol: RolService) {
    this._caseInformation = caseinfo;
  }

  /* Perfiles para RAS */
  get approvalRasOfficer() {
    return (
      this.rol.complianceOfficerRas &&
      this._caseInformation.approvalStatus == 'requestLevelTwo'
    );
  }

  get approvalRasManager() {
    return (
      this.rol.managerRas &&
      this._caseInformation.approvalStatus == 'requestLevelOne'
    );
  }

  /* Perfiles para Detección de Fraudes */
  get approvalSupervisorDet() {
    return (
      this.rol.supervisorDet &&
      this._caseInformation.approvalStatus == 'requestLevelOne'
    );
  }

  get approvalGerenteDet() {
    return (
      this.rol.gerenteDet &&
      this._caseInformation.approvalStatus == 'requestLevelTwo'
    );
  }

  public get needApproval() {
    return (
      this.approvalRasManager ||
      this.approvalRasOfficer ||
      this.approvalGerenteDet ||
      this.approvalSupervisorDet
    );
  }
}
